import { render, staticRenderFns } from "./frequencyModal.vue?vue&type=template&id=5b9a2d13&scoped=true&"
import script from "./frequencyModal.vue?vue&type=script&lang=js&"
export * from "./frequencyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9a2d13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b9a2d13')) {
      api.createRecord('5b9a2d13', component.options)
    } else {
      api.reload('5b9a2d13', component.options)
    }
    module.hot.accept("./frequencyModal.vue?vue&type=template&id=5b9a2d13&scoped=true&", function () {
      api.rerender('5b9a2d13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/highRiskDataManagement/components/frequencyModal.vue"
export default component.exports